export default "__VITE_ASSET__DwdOLV47__"